<template>
    <main>
       <v-dialog v-model="modalScanner"  max-width="600" max-height="98%" persistent>
            <div class="J-modal-login">
                <div class="J-modal-close">
                    <button type="button" class="close" @click="modalScanner=false">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                 <scanner-partials v-if="modalScanner"/>

            </div>
        </v-dialog>
        <div class="J-container-maps" id="map-wrap">
            <l-map :zoom=15 :center="[latitude, longitude]"  @click="addMarker">
                <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"></l-tile-layer>
                <l-circle :lat-lng="[latitude, longitude]" color='rgba(0,0,0,.0)' fillColor="#3388FF" :radius="100"></l-circle>
                <l-circle :lat-lng="[latitude, longitude]" color='red' fillColor="#f03" :radius="1000*my_distance"></l-circle>
                <span>
                    <l-circle :radius="40" v-if="covidDistance<=0.2" ref="myPosition" className="covid19" :lat-lng="[latitude, longitude]"  fillColor="#3388FF" color="#fff" :fillOpacity="1">
                        <l-popup  class="J-form-help-content" style="width: 250px;" v-if="user_help.status&&alertModal!='symptoms-help'" >
                            <div style="text-align:center" v-show="user_help.status!='pendiente'">
                                <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="createHelp">
                                    <v-layout class="text-xs-center J-form-help" column>
                                        <v-flex >
                                            <v-textarea class="flex-center J-input-text-area J-form-help-text" v-model="help.message" :rules="[rules.required]" :hide-details='true' required placeholder="Mensaje" outline></v-textarea>
                                        </v-flex>
                                        <v-flex >
                                            <v-text-field class="flex-center J-form-help-input J-form-help-number"  v-model="help.direction" :rules="[rules.required]"  :hide-details='true' required placeholder="Referencia ej: Al frente del local..." outline></v-text-field>
                                        </v-flex>
                                        <div>
                                            <v-text-field @keypress="validNumber" class="flex-center J-form-help-input J-form-help-number" :rules="[rules.required,rules.max,rules.min]"   v-model="help.phone"  :hide-details='true' required placeholder="N° celular" minlength="6" maxlength="20" outline></v-text-field>
                                        </div>
                                    </v-layout>
                                    <v-btn color="#11679a" class="J-form-help-btn" type="submit" :disabled="!valid" style="color:white">{{view_tabs[1].active?'SOLICITAR AYUDA':"CREAR LISTA PEDIDO"}}</v-btn>
                                </v-form>
                            </div>
                            <div v-show="user_help.status=='pendiente'"  class="text-xs-center  J-help-container">
                                <div class="J-help-content">
                                    <div class="J-help-message" :style="'background-color:#'+user_help.color">
                                        Creaste este mensaje: {{user_help.message}}
                                    </div>
                                     <!-- <upload-partials @action="savePhoto($event,user_help)"/> -->
                                    <span v-if="false" style="color:#fa5252; font-weight:bold">Por favor para crear uno nuevo finaliza su ayuda</span>
                                    <span style="color:#fa5252; font-weight:bold">
                                        Esté pendiente, su ayuda fue enviado a personas que esten cerca a usted.
                                    </span>
                                </div>
                                <button  type="button" class="btn btn-sm J-help-btn-danger" style="color: white;margin:5%" @click="clearLocation(),finishHelp(user_help)">Finalizar</button>
                                <button class="btn btn-sm J-help-btn" type="button" style="color: white;margin:5%" @click="clearLocation(),viewHelp(user_help)">Ver ayuda</button>
                                <div class="J-help-date">{{moment(user_help.created_at).fromNow()}}</div>

                            </div>
                        </l-popup>
                        <l-popup  class="J-form-help-content" style="width: 250px;" v-else>
                            <v-form ref="form" v-model="validSymptoms" lazy-validation @submit.prevent="createSymptoms">
                                <div class="J-form-help-check J-form-check-columns">
                                    <div class="J-form-help-title">
                                        ¿Tienes uno o más de los siguientes síntomas?
                                    </div>
                                    <div class="J-form-check-item" v-for="(item,i) in symptoms.symptoms" :key="i+1">
                                        <v-checkbox :hide-details='true' v-model="item.value" :value="!item.value" class="shrink mr-2 mt-0" :disabled="symptoms.percentage>60&&symptoms.id!=null?true:false" on-icon="fas fa-check" off-icon=" " :label="item.label"></v-checkbox>
                                    </div>
                                    <div v-if="symptoms.id==null&&user==null">
                                        <v-text-field class="flex-center J-form-help-input J-form-help-number" @keypress="validNumber" :rules="[rules.required,rules.max,rules.min]"  v-model="symptoms.phone"  :hide-details='true' required placeholder="N° celular" outline></v-text-field>
                                    </div>
                                    <div v-if="symptoms.id==null&&user.phone==''">
                                        <v-text-field class="flex-center J-form-help-input J-form-help-number" @keypress="validNumber" :rules="[rules.required,rules.max,rules.min]"  v-model="symptoms.phone"  :hide-details='true' required placeholder="N° celular" outline></v-text-field>
                                    </div>
                                    <div class="text-center">
                                        <div v-if="symptoms.id==null" style="color:#fa5252">
                                            Al realizar click en guardar aceptas compartir tu ubicacion de manera privada y solo personas autorizadas podrán ver la ubicacion exacta, mientras los demas solo seran alertadas a un radio de 200 metros.
                                        </div>
                                        <v-btn color="#11679a" class="J-form-help-btn" type="submit" :disabled="!validSymptoms||(symptoms.percentage>60&&symptoms.id!=null?true:false)" style="color:white">
                                            {{symptoms.id!=null?'EDITAR':'GUARDAR'}}
                                        </v-btn>
                                        <v-btn  v-if="symptoms.id!=null" class="J-help-btn-danger" type="button" @click="finishSymptoms()" :disabled="symptoms.percentage>60&&symptoms.id!=null?true:false" style="color:white">FINALIZAR</v-btn>
                                        <div v-if="symptoms.percentage>60&&symptoms.id!=null" style="color:#fa5252">
                                            Sus síntomas son de una probabilidad alta, por favor debes realizar el examen de descarte.
                                        </div>
                                    </div>
                                </div>
                            </v-form>
                        </l-popup>
                    </l-circle>
                    <l-circle-marker v-else  ref="myPosition" :lat-lng="[latitude, longitude]"  fillColor="#3388FF" color="#fff" :fillOpacity="1">
                        <l-popup  class="J-form-help-content" style="width: 250px;" v-if="user_help.status&&alertModal!='symptoms-help'" >
                            <div style="text-align:center" v-show="user_help.status!='pendiente'">
                                <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="createHelp">
                                    <v-layout class="text-xs-center J-form-help" column>
                                        <v-flex >
                                            <v-textarea class="flex-center J-input-text-area J-form-help-text" v-model="help.message" :rules="[rules.required]" :hide-details='true' required placeholder="Mensaje" outline></v-textarea>
                                        </v-flex>
                                        <v-flex >
                                            <v-text-field class="flex-center J-form-help-input J-form-help-number"  v-model="help.direction" :rules="[rules.required]"  :hide-details='true' required placeholder="Referencia ej: Al frente del local..." outline></v-text-field>
                                        </v-flex>
                                        <div>
                                            <v-text-field @keypress="validNumber" class="flex-center J-form-help-input J-form-help-number" :rules="[rules.required,rules.max,rules.min]"   v-model="help.phone"  :hide-details='true' required placeholder="N° celular" minlength="6" maxlength="20" outline></v-text-field>
                                        </div>
                                    </v-layout>
                                    <v-btn color="#11679a" class="J-form-help-btn" type="submit" :disabled="!valid" style="color:white">{{view_tabs[1].active?'SOLICITAR AYUDA':"CREAR LISTA DE PEDIDO"}}</v-btn>
                                </v-form>
                            </div>
                            <div v-show="user_help.status=='pendiente'"  class="text-xs-center J-help-container">
                                <div class="J-help-content">
                                    <div class="J-help-message" :style="'background-color:#'+user_help.color">
                                        Creaste este mensaje: {{user_help.message}}
                                    </div>
                                    <!-- <upload-partials @action="savePhoto($event,user_help)"/> -->
                                    <span v-if="false" style="color:#fa5252; font-weight:bold">Por favor para crear uno nuevo finaliza su ayuda</span>
                                    <span style="color:#fa5252; font-weight:bold">
                                        Esté pendiente, su ayuda fue enviado a personas que esten cerca a usted.
                                    </span>
                                </div>
                                <button  type="button" class="btn btn-sm J-help-btn-danger" style="color: white;margin:5%" @click="clearLocation(),finishHelp(user_help)">Finalizar</button>
                                <button class="btn btn-sm J-help-btn" type="button" style="color: white;margin:5%" @click="clearLocation(),viewHelp(user_help)">Ver ayuda</button>
                                <div class="J-help-date">{{moment(user_help.created_at).fromNow()}}</div>
                            </div>
                        </l-popup>
                        <l-popup  class="J-form-help-content" style="width: 250px;" v-else>
                            <v-form ref="form" v-model="validSymptoms" lazy-validation @submit.prevent="createSymptoms">
                                <div class="J-form-help-check J-form-check-columns">
                                    <div class="J-form-help-title">
                                        ¿Tienes uno o más de los siguientes síntomas?
                                    </div>
                                    <div class="J-form-check-item" v-for="(item,i) in symptoms.symptoms" :key="i+1">
                                        <v-checkbox :hide-details='true' v-model="item.value" :value="!item.value" class="shrink mr-2 mt-0" :disabled="symptoms.percentage>60&&symptoms.id!=null?true:false" on-icon="fas fa-check" off-icon=" " :label="item.label"></v-checkbox>
                                    </div>

                                    <div v-if="symptoms.id==null&&user==null">
                                        <v-text-field @keypress="validNumber" class="flex-center J-form-help-input J-form-help-number" :rules="[rules.required,rules.max,rules.min]"   v-model="symptoms.phone"  :hide-details='true' required placeholder="N° celular" minlength="6" maxlength="20" outline></v-text-field>
                                    </div>
                                    <div v-else-if="symptoms.id==null&&user.phone==''">
                                        <v-text-field @keypress="validNumber" class="flex-center J-form-help-input J-form-help-number" :rules="[rules.required,rules.max,rules.min]"   v-model="symptoms.phone"  :hide-details='true' required placeholder="N° celular" minlength="6" maxlength="20" outline></v-text-field>
                                    </div>
                                    <div class="text-center">
                                        <div v-if="symptoms.id==null" style="color:#fa5252">
                                            Al realizar click en guardar aceptas compartir tu ubicacion de manera privada y solo personas autorizadas podrán ver la ubicacion exacta, mientras los demas solo seran alertadas a un radio de 200 metros.
                                        </div>
                                        <v-btn color="#11679a" class="J-form-help-btn" type="submit" :disabled="!validSymptoms||(symptoms.percentage>60&&symptoms.id!=null?true:false)" style="color:white">
                                            {{symptoms.id!=null?'EDITAR':'GUARDAR'}}
                                        </v-btn>
                                        <v-btn color="#fa5252" v-if="symptoms.id!=null" type="button" @click="finishSymptoms()" :disabled="symptoms.percentage>60&&symptoms.id!=null?true:false" style="color:white">FINALIZAR</v-btn>
                                        <div v-if="symptoms.percentage>60&&symptoms.id!=null" style="color:#fa5252">
                                            Sus síntomas son de una probabilidad alta, por favor debes realizar el examen de descarte.
                                        </div>
                                    </div>
                                </div>
                            </v-form>
                        </l-popup>
                    </l-circle-marker>
                </span>
                <l-circle v-if="selected.selected" :lat-lng="[selected.latitude, selected.longitude]" color="rgba(0,0,0,.0)" fillColor="rgb(7, 232, 244)" :radius="100"></l-circle>
                <span  v-for="(item,index) in newMaker" :key="index">
                    <l-marker v-if="!item.type" :lat-lng="[item.latitude, item.longitude]" @click="searchCoupons(item)" :fillOpacity="1" @add="$nextTick(() => {checkNext($event,item,index)})">
                        <l-icon :iconUrl="checkedIcon(item)"  :iconAnchor=[30,60] :iconSize="[60,60]"></l-icon>
                         
                    </l-marker>
                    <l-circle v-else-if="item.type==='user-covid19'" :lat-lng="[item.latitude, item.longitude]" color='rgba(0,0,0,.0)' fillColor="#38988b" :fillOpacity=".2" :radius="200"></l-circle>
                    <l-circle-marker v-else :lat-lng="[item.latitude, item.longitude]"  :fillColor="'#'+item.color" color="#fff" :fillOpacity="1" @add="$nextTick(() => checkNext($event,item,index))">
                        <l-popup style="width: 250px;">
                            <div class="J-help-container" v-if="item.type==='user-helping'">
                                <h4 class="J-help-title" v-if="item.user">{{item.user.name}}</h4>
                                <div class="J-help-content">
                                    <div class="J-help-message" :style="'background-color:#'+item.color">
                                        Quiero ayudarte
                                    </div>
                                </div>
                                <button class="btn btn-sm J-help-btn" style="color: white;margin:5%" @click="clearLocation(),selectUserHelp(item)">Recibir ayuda</button>
                            </div>
                            <div class="J-help-container" v-else>
                                <h4 class="J-help-title" v-if="item.user">{{item.user.name}}</h4>
                                <div class="J-help-content">
                                    <div class="J-help-message" :style="'background-color:#'+item.color">
                                        {{item.user.message}}
                                    </div>
                                </div>
                                <button class="btn btn-sm J-help-btn" style="color: white;margin:5%" @click="clearLocation(),selectUser(item)">Ayudar</button>
                                <span class="J-help-date">{{moment(item.created_at).fromNow()}}</span>
                            </div>
                        </l-popup>
                    </l-circle-marker>
                </span>
            </l-map>
        </div>

        <div class="J-btn-content J-btn-content-slide slide-search">
            <button class="btn J-btn-fixed J-btn-search tooltip-slide J-slide-btn" aria-label="Abrir busquedas"   data-balloon-pos="right" @click="isOpenSearch()">
                <i class="fas fa-angle-double-right" v-if="!openOptionSearch"></i>
                <i class="fas fa-angle-double-left" v-else></i>
            </button>
        </div>
        <div class="J-search-list-content"  :class="{'show':openOptionSearch,'hide':!openOptionSearch}" @click="removeSearchSelected('price')" v-if="search.price_from!=null&&search.price_from!=0&&search.price_to!=null&&search.price_to!=0">
            <div class="J-search-list-text">
                Precios desde S/. {{search.price_from}} hasta S/.{{search.price_to}}
            </div>
            <span class="J-search-list-icon">
                <i class="fas fa-times"></i>
            </span>
        </div>
        <div class="J-search-list-content" :class="{'show':openOptionSearch,'hide':!openOptionSearch}" v-if="my_distance" @click="removeSearchSelected('distance')">
            <div class="J-search-list-text" aria-label="Eliminar filtro"  data-balloon-pos="down">
                Distancia de: {{my_distance}} km
            </div>
            <span class="J-search-list-icon">
                <i class="fas fa-times"></i>
            </span>
        </div>
        <div class="J-search-list-content" :class="{'show':openOptionSearch,'hide':!openOptionSearch}" v-if="id_company!=0" @click="removeSearchSelected('name')" :title="'Eliminar filtro '+name_company+''">
            <div class="J-search-list-text">
                {{this.name_company}}
            </div>
            <span class="J-search-list-icon">
                <i class="fas fa-times"></i>
            </span>
        </div>
        <div class="J-search-list-content" :class="{'show':openOptionSearch,'hide':!openOptionSearch}" v-if="false" @click="removeSearchSelected('type')">
            <div class="J-search-list-text" aria-label="Eliminar filtro"  data-balloon-pos="down">
                {{this.search_type}}
            </div>
            <span class="J-search-list-icon">
                <i class="fas fa-times"></i>
            </span>
        </div>
        <div class="J-btn-content J-btn-content-slide slide">
            <button class="btn J-btn-fixed J-btn-search tooltip-slide J-slide-btn" aria-label="Abrir opciones"   data-balloon-pos="left" @click="isOpen()">
                <i class="fas fa-angle-double-left" v-if="!openOption"></i>
                <i class="fas fa-angle-double-right" v-else></i>
            </button>
        </div>
        <div class="J-btn-content price" :class="{'show':openOption,'hide':!openOption}" v-if="false">
            <div class="J-btn-text" :class="{'active':tabs[0].active}" >
                <div class="text-center" style="width:80%">
                    <ul class="J-filters-items-content  J-m-t-10  J-m-b-25">
                        <li class="J-filters-items" v-for="(item,i) in view_tabs" @click="isViewActive(i)" :key="i+1">
                            <span class="J-filters-icon" v-if="item.active"><i class="fas fa-check"></i></span>
                            <span class="J-filters-number">{{item.name}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="J-btn-decoration" :class="{'active':tabs[0].active}">
            </div>
            <button class="btn J-btn-fixed J-btn-search tooltip-slide" aria-label="Apps de gootwork"   data-balloon-pos="up-right" @click="isTabActive(0)">
                <span class="J-svg-container">
                    <svg class="J-svg-icon" focusable="false" viewBox="0 0 24 24"><path d="M6,8c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM12,20c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM6,20c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM6,14c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM12,14c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM16,6c0,1.1 0.9,2 2,2s2,-0.9 2,-2 -0.9,-2 -2,-2 -2,0.9 -2,2zM12,8c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM18,14c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM18,20c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2z"></path></svg>
                </span>
            </button>

        </div>
        <!--
        <div class="J-btn-content price">
            <div class="J-btn-text" :class="{'active':tabs[0].active}"  v-show="tabs[0].active">
                <div class="text-center">
                    <input type="number" v-model="search.price_from" class="J-m-t-15" placeholder="Desde">
                    <input type="number" v-model="search.price_to" class="J-m-b-5" placeholder="Hasta">
                    <button @click="searchPrice()" class="v-btn theme--dark text-center J-m-b-15 J-btn-search-md">buscar</button>
                </div>
            </div>
            <div class="J-btn-decoration" :class="{'active':tabs[0].active}">
            </div>
            <button class="btn J-btn-fixed J-btn-search"  data-toggle="tooltip" title="Buscar lavanderias por precio" @click="isTabActive(0)"><i class="fas fa-dollar-sign"></i></button>
        </div>
        -->
        <div class="J-btn-content longitude"  :class="{'show':openOption,'hide':!openOption}">
            <div class="J-btn-text" :class="{'active':tabs[1].active}" >
                <div class="text-center">
                    <search-auto-complete class="J-m-t-15" @selected="selectedAddress" @keyChange="keyChange"></search-auto-complete>
                    <ul class="J-filters-items-content  J-m-t-10  J-m-b-25">
                        <li class="J-filters-items" v-for="(item,i) in distance" :key="i+1" @click="activeDistance(item.value,i)">
                            <span class="J-filters-icon" v-if="item.active"><i class="fas fa-check"></i></span>
                            <span class="J-filters-number">{{item.name}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="J-btn-decoration" :class="{'active':tabs[1].active}">
            </div>
           <button class="btn J-btn-fixed J-btn-search" aria-label="Buscar por distancia"  data-balloon-pos="up-right" @click="isTabActive(1)"><i class="fas fa-map-marked-alt"></i></button>
        </div>
        <!-- <div class="J-btn-content name-company">
            <button class="btn J-btn-fixed J-btn-search" data-toggle="tooltip" title="Buscar zonas de peligro en contacto" @click="searchDanger()">
                <i class="fas fa-search-location"></i>
            </button>
        </div> -->
        <div class="J-btn-content J-name-company"  :class="{'show':openOption,'hide':!openOption}">
            <button class="btn J-btn-fixed J-btn-search"  aria-label="Activar ubicacion"  data-balloon-pos="left" @click="getCurrentLocation()">
                <i v-if="!successpositioncondition" class="material-icons">location_searching</i>
                <i v-else class="material-icons">my_location</i>

            </button>
        </div>
        <!--
        <div class="J-btn-content name-company">
            <div class="J-btn-text search-text" :class="{'active':tabs[2].active}"  v-show="tabs[2].active">
                <search :placeholder="'Nombre de una lavanderia'" @selected="selectedCompany"/>
            </div>
            <div class="J-btn-decoration" :class="{'active':tabs[2].active}">
            </div>
            <button class="btn J-btn-fixed J-btn-search" data-toggle="tooltip" title="Buscar lavanderias por nombre" @click="isTabActive(2)"><i class="fas fa-search"></i></button>
        </div>
        -->
        <!--
        <div class="J-btn-content favorites">
            <div class="J-btn-text" :class="{'active':tabs[3].active}" v-show="tabs[3].active" v-if="dataFavorites!=null">
                <div class="text-center" style="width:200px">
                    <ul class="J-filters-items-content  m-t-10 J-m-b-25">
                        <li class="J-filters-items" v-for="(item,i) in dataFavorites" :key="i+1" data-toggle="tooltip" :title="item.name" @click="selectedFavorite(item)">
                            <span class="J-filters-icon"><i class="fas fa-star"></i></span>
                            <span class="J-filters-number">{{item.name.slice(0,20)}}...</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="J-btn-decoration" :class="{'active':tabs[3].active}" v-if="dataFavorites!=null">
            </div>
            <button class="btn J-btn-fixed J-btn-search" data-toggle="tooltip" title="Favoritos" @click="isTabActive(3),checkedFavorite()"><i class="far fa-star"></i></button>
        </div>
        
        -->
        <div class="J-btn-content favorites"  :class="{'show':openOption,'hide':!openOption}" v-if="false">
            <button class="btn J-btn-fixed J-btn-search" @click="openScanner()" aria-label="Escanear"  data-balloon-pos="left"><i class="fas fa-qrcode"></i></button>
        </div>
        <!-- <div class="J-btn-content favorites"  :class="{'show':openOption,'hide':!openOption}">
            <button class="btn J-btn-fixed J-btn-search" aria-label="Compartir"  data-balloon-pos="left" @click="social('facebook')"><i class="fas fa-share-alt"></i></button>
        </div>
         -->

    </main>
</template>
<script>
const alertify = require('alertifyjs')
 alertify.set('notifier','position', 'top-center');

import { EventBus } from '@/helpers/eventbus/event-bus';

import initVue from '../../../helpers/initVue.js';


// var popupcontent = '<br><button class="btn btn-warning btn-sm" style="color: white;margin:5% 0% 0% 35%;" @click="addStops(' + loc + ')">Add</button>'
import { LCircle, LCircleMarker, LIcon, LMap, LMarker, LPopup, LTileLayer, LTooltip } from 'vue2-leaflet';

import { ActiveLocationStorage, CartStorage, CompanyStorage, CouponStorage, FavoritesStorage, HelpModalStorage, HelpStorage, LocationStorage, OrderDetailStorage, OrderStorage, ReferredStorage, SearchListStorage, SymptomsStorage, UsersStorage } from '@/helpers/storage.js';
import { Help, Symptoms } from '@/models';
import { CouponsService, HelpService } from '@/services';
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import moment from 'moment';
moment.locale('es');
// import selected from 'selected';

//var notification = alertify.notify('sample kd sdjos sdoj sdoijn sdoins siodn sdnois sdinos', 'success', 390, function(){  console.log('dismissed'); });

export default {
    data: () => ({
            openOption:false,
            openOptionSearch:false,
            PERMISSION_DENIED:false,
            disabled_btn:false,
            covidDistance:1,
            symptoms:new Symptoms(),
            user_location_cache:null,
            time_get:0,
            shared_location_all:false,
            moment:moment,
            search_type:"Estas: en Gootwork negocios",
            my_distance:1,
            valid:true,
            validSymptoms:false,
            watchID:null,
            search:{
                price_from:null,
                price_to:null,
            },
            view_tabs:[
                {value:"busines",name:"GW negocios",active:false},
                {value:"help",name:"GW favor con favor",active:false},
                // {value:"search-help",name:"Busco ayuda",active:false},
                // {value:"symptoms-help",name:"Tengo síntomas",active:false},
            ],
            distance:[
                {value:0,name:"Ninguno",active:false},
                {value:1,name:"A 1 kilometro",active:true},
                {value:3,name:"A 3 kilometro",active:false},
                {value:5,name:"A 5 kilometro",active:false},
                {value:10,name:"A 10 kilometro",active:false},
            ],
            tabs:[
                {id:1,name:'price',active:false},
                {id:2,name:'longitude',active:false},
                {id:3,name:'name',active:false},
                {id:4,name:'favorites',active:false},
            ],
            inputgeosearch: false,
            text: 'El Tambo',
            geosearchOptions: { // Important part Here
                provider: new OpenStreetMapProvider(),
            },
            activeLocationStorage:new ActiveLocationStorage(),
            latitude:new ActiveLocationStorage().get()==true?0:-12.0681, 
            longitude:new ActiveLocationStorage().get()==true?0:-75.2106,
            marker:[

            ],
            locationFirst:false,
            selected:{
                selected:false,
                latitude:null,
                longitude:null,
            },
            id_company:0,
            name_company:'',
            identity:null,
            token:null,
            session:false,
            imageUrl: 'https://picsum.photos/510/300?random',
            newMaker:[],
            rules: {
                required: value => !!value || 'Requerido.',
                max:(value)=>value.length<=20||'Max is of 20',
                min:value=>value.length>=6||'Min is of 6'
            },
            layers:[
                {
                    id: 0,
                    name: 'Restaurants',
                    active: false,
                    features: [ /* snip */ ],
                },
                {
                    id: 1,
                    name: 'City/County Boundaries',
                    active: false,
                    features: [],
                }
            ],
            channel:{
                channelCompany:'',
                id:1,
            },
            alertModal:'',
            datacovid19:[],
            user_help:{status:'crear'},
            help:new Help(),
            orderStorage:new OrderStorage(),
            orderDetailStorage:new OrderDetailStorage(),
            companyStorage:new CompanyStorage(),
            symptomsStorage:new SymptomsStorage(),
            cartStorage:new CartStorage(),
            favoritesStorage:new FavoritesStorage(),
            couponStorage:new CouponStorage(),
            referredStorage:new ReferredStorage(),
            searchListStorage:new SearchListStorage(),
            
            usersStorage:new UsersStorage(),
            locationStorage:new LocationStorage(),
            helpStorage:new HelpStorage(),
            helpModalStorage:new HelpModalStorage(),
            dataFavorites:[],
            successpositioncondition: false,
            countMaker:0,
            activePopup:null,
            countML:0,
            user:null,
            countPress:0,
            modalScanner:false,
            coupons:[]
    }),
    sockets:{
        'symptoms-alert'(data){
            if(data!=null){
                this.createPosible(data)
            }
        },
        
        'location:user-helping'(data){
            if(data!=null){
                this.newMaker.push(
                        {
                            type:'user-helping',
                            latitude:data.location[1],
                            created_at:data.created_at,
                            longitude:data.location[0],
                            channel:data.user._id,
                            color:'11679a',
                            user:{
                                ...data.user,
                            }
                        }
                )
           }
        },
        'help-alert'(data){
            if(data!=null){
                this.newMaker.push(
                {
                    type:'user',
                    new_help:true,
                    created_at:data.created_at,
                    latitude:data.location.coordinates[1],
                    longitude:data.location.coordinates[0],
                    channel:data.user._id_user,
                    color:data.user.priority=='alta'?'fa5252':"ffc107",
                    user:{
                        ...data.user,
                    }
                }
            )
           }
        },
        connection(data){
           
        },
        message(data){
          //console.log(data,' :client');
        },
        'location:me'(data){
           var newMarker=[];
           
           if(data !=null){
               data.forEach(element=>{
                    newMarker.push(
                            {
                                latitude:element.location.coordinates[1],
                                longitude:element.location.coordinates[0],
                                channel:element.company._id_company,
                                company:{
                                    ...element.company,
                                }
                            }
                    )
                })
                this.newMaker=newMarker;
           }
           //console.log(this.newMarker);
        },
        location(data){
            //console.log(data);
            data.forEach(element=>{
                this.newMaker.push(element);
            })
            
        }
    },
    computed:{
        checkCovid19(){
            if(this.covidDistance<=0.2){
                return true;
            }
            return false;
        },
        checkedDate(){
            var date_created=moment(this.user_help.created_at).add(2,'hours')
            var now=moment()
            if(date_created<=now){
                return true;
            }
            else{
                return false;
            }
        },
    },
    async mounted() {
        this.getidentity()
        //this.checked()
        
        this.getCheckedCurrentLocation();
        let routeisindex = this.$route.name === 'Index'
        
        var {coupon}=this.$route.query;
        if(!coupon){
            this.getLocation()
        }
        if(routeisindex){
            this.inputgeosearch = false
        }else if(!this.session){
            this.inputgeosearch = false
        }else{
            this.inputgeosearch = true
            document.getElementsByClassName('glass')[3].setAttribute("placeholder","Escriba su Dirección")
        }
        if(this.session){
            this.findUser();
            this.checkedSymtoms()
        }
        var modalHelp=this.helpModalStorage.get()
        if(!modalHelp){
            EventBus.$emit('goModalHelp')
        }
        else{
           this.checkedAlert(modalHelp);
        }
        EventBus.$on('searchList',(data)=>{
            this.selectedCompany(data);
            this.searchListStorage.set(data.services);
        })
        EventBus.$on('alert', (data) =>{
            this.checkedAlert(data)
        })
        EventBus.$on('search-maps',(data)=>{
            this.searchCategory(data)
        })
        var users=this.usersStorage.get()||{phone:''};
        this.user=users;
        this.selectedQuery()
        this.isViewActive(0,"help")
        if(users){
            this.help.phone=users.phone
        }
    },
    components:{
        LMap, LTileLayer, LMarker,LPopup,LTooltip,LCircle,LCircleMarker,LIcon,
        VGeosearch:()=>import('vue2-leaflet-geosearch'),
        SearchAutoComplete:()=>import('@/components/partials/SearchAutoComplete'),
        Search:()=>()=>import('@/components/partials/Search'),
        UploadPartials:()=>import('@/components/partials/Upload.partials.vue'),
        ScannerPartials:()=>import('@/components/partials/Scanner.partials.vue'),
    },
    methods:{
        openScanner(){
            this.modalScanner=true
        },
        isOpenSearch(){
            this.openOptionSearch=!this.openOptionSearch

        },
        isOpen(){
            this.openOption=!this.openOption
        },
        calculateMt(item){

            var distance=item.calculated
            if(!distance){
               distance=this.getKilometros(this.latitude,this.longitude,item.latitude,item.longitude);
            }
            var mt=distance*1000;
            if(mt>=1000){
                var km= Math.trunc(distance);
                var mt=(distance%1)*1000;
                return `a ${km.toFixed(0)} km & ${mt.toFixed(0)} mt`
            }

            // var g=this.getKilometros(this.latitude,this.longitude,element.latitude,element.longitude);
            return `a ${mt.toFixed(0)} mt`
        },
        checkNext($e,data,i){
            $e.target.isRandom = true;
            $e.target.autoClose = false;
            if(i==0){
                this.searchCoupons(data);
                this.activePopup=$e;
                $e.target.openPopup()
                
            }
            
            // if(this.newMaker.length-1==i){
            //     this.activePopup.target.openPopup()
            // }
            // this.countML++;
            //  e.target.openPopup()
        },
        searchCoupons(data){
            this.coupons=[];
            var query={
                id_company:data.company._id_company,
                id_office:data.company._id_office,
            }
            CouponsService.listPublic(query)
            .then(res=>{
                var {data}=res.data;
                this.coupons=data;
            })

        },
        savePhoto(data,user_help){
            var dataSend={
                id:user_help.id,
                image:data,
            }
            HelpService.uploadHelp(dataSend).then(res=>{
                console.log(res)
            })
        },
        checkedIcon(data){
            try{
                var url="/img/markers/bodegas.svg";
                if(data.company.category==undefined){
                    return "/img/markers/bodegas.svg";                    
                }
                switch(data.company.category){
                    case "lavanderia":
                        url="/img/markers/lavanderias.svg";
                        break;
                    case "restaurante":
                        url="/img/markers/restaurante.svg";
                        break;
                    default:
                        url="/img/markers/bodegas.svg";
                        break;
                }
                return url;
            }
            catch($e){
                return "/img/markers/bodegas.svg";
            }
        },
        searchDanger:function(){
            EventBus.$emit('goModalDanger')
        },
        validNumber:function(e){
            var key=window.event?e.which:e.keyCode
            if(key<48||key>57){
                e.preventDefault()
            }
        },
        activeHelp:function(){
            this.alertModal='search-help';

        },
        finishSymptoms:function(){
            if(this.symptoms.id!=null){
                HelpService.finishSymptoms({id:this.symptoms.id}).then(res=>{
                    this.symptomsStorage.remove();
                    alertify.success('Test finalizado')
                    this.symptoms=new Symptoms();
                })
                .catch(err=>{
                    alertify.error('Test no finalizado')
                    console.log(err)
                })
            }
        },
        createPosible:function(data){
            var datastorage=this.usersStorage.get();

            var datauser={
                id:this.identity._id,
                _id_symptom:data.user._id_symptom,
                name:datastorage.fullname,
                photo:datastorage.photo
            }
            var user={
                'id':this.identity._id,
                'user':datauser,
                'latitude':this.latitude,
                'longitude':this.longitude,
            };
            this.$socket.emit('location:user-posible',user);
        },
        checkedSymtoms:function(){
            this.session = JSON.parse(localStorage.getItem('user'))
            if(this.session){
                var symptoms=this.symptomsStorage.get()
                if(symptoms==null){
                    HelpService.findSymptomps().then(res=>{
                        var {data}=res.data
                        this.symptomsStorage.set(data)
                        this.addValSymptomp();

                    })
                    .catch(err=>{
                        this.symptomsStorage.set('none')
                    })
                }
                else{
                    if(symptoms!='none'){
                        this.shared_location_all=true;
                        this.addValSymptomp();
                    }
                    else{
                        this.shared_location_all=false;

                    }
                }
            }
        },
        addValSymptomp:function(){
            var symptoms=this.symptomsStorage.get()
            var i=0;
            symptoms.detail.forEach(el=>{
                i++;
                var index=this.symptoms.symptoms.findIndex(element=>{return element.val==el})
                if(index!=-1){
                    this.$set(this.symptoms.symptoms[index],'value',true);
                }
            })
            
            this.symptoms.percentage=i*100/5;
            this.symptoms.id=symptoms.user._id_symptom;
            this.shared_location_all=true;
        },
        createSymptoms:function(e){
            
            this.disabled_btn=true;
            this.session = JSON.parse(localStorage.getItem('user'))
            
            if(!this.session){
                this.disabled_btn=false;
                EventBus.$emit('goLogin')
                return;
            }
            if (this.$refs.form.validate()) {
                var count=0;
                this.symptoms.symptoms.forEach(el=>{
                    if(el.value==true){
                        count++;
                    }
                })  
                if(count==0){
                    alertify.error('Por favor seleccione'); 
                    this.disabled_btn=false;

                    return;
                }     
                if(this.symptoms.id==null){
                    if(this.symptoms.phone!=''){
                        this.user.phone=this.symptoms.phone;
                    }
                    HelpService.createTest(this.symptoms).then(res=>{
                        var {data}=res.data;
                        this.shared_location_all=true;
                        this.symptomsStorage.set(data)
                        alertify.success('Test creada')
                        this.addValSymptomp();
                        this.disabled_btn=false;
                        this.usersStorage.set(this.user);
                        this.newMaker=[];

                    })
                    .catch(err=>{
                        this.valid=true;
                        alertify.error('Test no creada')
                        this.disabled_btn=false;
                    })
                }
                else{
                    HelpService.updateTest(this.symptoms).then(res=>{
                        var {data}=res.data;
                        this.shared_location_all=true;
                        this.symptomsStorage.set(data)
                        alertify.success('Test editada')
                        this.addValSymptomp();
                        this.disabled_btn=false;

                    })
                    .catch(err=>{
                        this.disabled_btn=false;

                        alertify.error('Test no editada')
                    })
                }
            }
            else{
                alertify.error('Por favor rellene los campos')
                this.disabled_btn=false;                
            }
        },
        checkedAlertCovid:function(){
            this.datacovid19.forEach(el=>{
                var dist=this.getKilometros(el.latitude,el.longitude,this.latitude,this.longitude);
                if(dist){
                    this.covidDistance=dist;
                    if(dist<=0.2){
                        if(dist<=0.05){
                            this.notificacionBasica(null,'Alto riesgo de contagio tenga cuidado')
                        }
                        else{
                            this.notificacionBasica(null,`Alerta de contagio a ${dist*1000} metros`)
                        }
                    }        
                }
            })
        },
        checkedAlert:function(data){
            this.isViewActive(null,data);            
            window.scrollTo(0, 0);
        },
        async viewHelp(data){
            this.session = JSON.parse(localStorage.getItem('user'))
            if(!this.session){
                EventBus.$emit('goLogin')
                return;
            }
            if(data.contacts.length==0){
                await this.helpStorage.remove();
                await this.findUser();
                if(this.user_help.contacts.length!=0){
                    this.$router.push(`/conversation-user?type=user&datauser=${this.user_help.contacts[0]._id}&color=${this.user_help.color}`)    
                    return;
                }
                else{
                    alertify.error('No tiene interesados aún en ayudarles para que entre al detalle de la ayuda')
                    return;
                }
            }
            this.$router.push(`/conversation-user?type=user&datauser=${data.contacts[0]._id}&color=${data.color}`)        
        },
        finishHelp(data){
            this.session = JSON.parse(localStorage.getItem('user'))
            if(!this.session){
                EventBus.$emit('goLogin')
                return;
            }
            axios.post('user/help-finish',{id:data.id})
            .then(res=>{
                this.user_help.status='crear'
                this.helpStorage.remove()
                alertify.success('Mensaje finalizado')
            })
            .catch(err=>{
                alertify.error('Su mensaje de ayuda no se finalizó')
            })
        },
        async findUser(){
            var help=this.helpStorage.get();
            if(help){
                this.user_help=help;
                return;
            }
            await this.axios.get(`user-search/${this.identity._id}`)
            .then(res=>{
                if(res.data !=null){
                    var {data}=res.data
                    if(data!=null){
                        
                        this.user_help=data.user;
                        this.user_help.id=data._id;
                        this.user_help.location=data.location;
                        this.user_help.created_at=data.created_at
                        this.user_help.color=data.priority=='alta'?'fa5252':"ffc107"
                        this.helpStorage.set(this.user_help)
                    }
                }
            })
        },
        createHelp:function(){
            
            if (this.$refs.form.validate()) {
                this.session = JSON.parse(localStorage.getItem('user'))
                if(!this.session){
                    EventBus.$emit('goLogin')
                    return;
                }

                var user=this.usersStorage.get()||null;
                this.help.user=user
                this.help.location=[this.longitude,this.latitude]
                this.countPress=0;
                HelpService.create(this.help).then(res=>{
                    this.valid=true;
                    var {data}=res.data
                    this.$socket.emit('help',data);
                    alertify.success('Ayuda creada')
                    this.help=new Help();
                    this.findUser();

                })
                .catch(err=>{
                    this.valid=true;
                    alertify.error('Ayuda no creada')
                })
            }
            else{
                this.valid=false;
            }
        },
        removeSearchSelected:function(type){
            switch(type){
                case "price":
                    this.search.price_from=0;
                    this.search.price_to=0;
                    this.searchOfficeId();
                    break;
                case "type":
                    this.search_type='';
                    this.searchOfficeId();
                    break;
                case "distance":
                    this.activeDistance(0,0);
                    break;
                case "name":
                    this.id_company=0;
                    this.name_company='';
                    this.searchOfficeId();
                    break;
            }

        },
        social(name){
            FB.init({
                appId: '461530364338382',
                status: true,
                xfbml: true,
                version: 'v6.0'
            });
            FB.ui({
                display: 'popup',
                method: 'feed',
                name: "GootWork startup peruano",                
                link: "https://gootwork.com",
                picture: 'https://gootwork.com/img/resources/captionfb.png',
                caption: 'No se tú, pero yo si pienso #quedateEncasa #GootWorkEnsolidaridad',
                description: "Lava cuando quieras, donde quieras, FACIL, RAPIDO Y SEGURO",
                action_properties: JSON.stringify({
                    object: {
                    'og:url': 'https://gootwork.com',
                    'og:title': 'GootWork startup peruano',
                    'og:description': 'No se tú, pero yo si pienso #quedateEncasa #GootWorkEnsolidaridad',
                    'og:image:width': '2560',
                    'og:image:height': '960',
                    'og:image': 'https://gootwork.com/img/resources/captionfb.png'
                    }
                })
                
            }, function(response){});

        },
        actionPopup(e,data=null){
            
            var modalHelp=this.helpModalStorage.get()
            if(data!=null){
                if(data.type=="user-helping"){
                    e.target.openPopup()
                }
                else if(data.new_help){
                    e.target.openPopup()
                }
                else{
                    e.target.openPopup()
                }
            }
            else if(this.countMaker==0&&modalHelp!='search-help'){
                e.target.openPopup()
            }
            this.countMaker++;
        },
        selectedQuery(){
            var {coupon,company,referred}=this.$route.query;
            if(referred){
                this.referredStorage.set(referred);
            }
            if(coupon){
                this.couponStorage.remove();
                var new_coupon={
                    key:coupon,
                    company:company
                };
                this.couponStorage.set(new_coupon);
            }
            else{
                var coupon=this.couponStorage.get();
                if(coupon){
                    this.id_company=coupon.company;
                    this.activeDistance(0,0)
                }
            }
            if(company){
                this.id_company=company;
                this.activeDistance(0,0)
            }
        },
        removeSearch(){
            this.id_company=0;
            this.search.price_from=0;
            this.search.price_to=0;
            this.activeDistance(1,1);
        },
        checkedFavorite(){

            this.dataFavorites=this.favoritesStorage.get();
        },
        selectedFavorite(data){
            this.name_company=data.name;
            this.id_company=data._idcompany;
            this.searchOfficeId();
        },
        selectedCompany(data){
            this.id_company=data._id;
            this.name_company=data.name;
            this.searchOfficeId();
        },
        searchCategory(data){
            axios.get(`/location?type=${this.search_type}&&id=${this.id_company}&&distance=${this.my_distance}&&latitude=${this.latitude}&&longitude=${this.longitude}&&from=${this.search.price_from}&&to=${this.search.price_to}&&category=${data}`)
            .then(res=>{
                var {data}=res
                this.addMakerMaps(data);
            }) 
        },
        searchOfficeId(){
             axios.get(`/location?type=${this.search_type}&&id=${this.id_company}&&distance=${this.my_distance}&&latitude=${this.latitude}&&longitude=${this.longitude}&&from=${this.search.price_from}&&to=${this.search.price_to}`)
            .then(res=>{
                var {data}=res
                this.addMakerMaps(data);
            }) 
        },
        searchPrice(){
             axios.get(`/location?type=${this.search_type}&&id=${this.id_company}&&distance=${this.my_distance}&&latitude=${this.latitude}&&longitude=${this.longitude}&&from=${this.search.price_from}&&to=${this.search.price_to}`)
            .then(res=>{
                var {data}=res
                this.addMakerMaps(data);
            }) 
        },
        getLocation:function(){
            
            axios.get(`/location?type=${this.search_type}&&id=${this.id_company}&&distance=${this.my_distance}&&latitude=${this.latitude}&&longitude=${this.longitude}&&from=${this.search.price_from}&&to=${this.search.price_to}`)
            .then(res=>{
                var {data}=res
                this.addMakerMaps(data);
                
            })
        },
        addMarker(event) {
            if(this.successpositioncondition){
                console.log("ingresando 1");
                return;
            }
            // if(this.shared_location_all==true){
            //     console.log("ingresando");
            //     return;
            // }
            var {lat,lng}=event.latlng;
            this.latitude=lat;
            this.longitude=lng
            this.searchPrice();
        },
        keyChange:function(data){
        },
        selectedAddress:function(data){

            this.latitude=data.raw.lat;
            this.longitude=data.raw.lon;
        },
        activeDistance:function(distance,i){
            this.distance.forEach(element=>{
                element.active=false
            })
            this.distance[i].active=true;
            this.searchDistance(distance);
        },
        searchDistance:function(distance){
            this.my_distance=distance;
            this.getLocation();
        },
        isViewActive:function(index,value){
            var data='';
            if(value=='busines-create'){
                value='busines'
                EventBus.$emit('companyregister')
            }
            
            var active=index!=null?this.view_tabs[index].active:false;
            this.view_tabs.forEach((element,i)=>{
                if(element.value==value){index=i; active=element.active}
                else element.active=false;
            });
            if(index!=null){
                this.view_tabs[index].active=true;
                value=this.view_tabs[index].value
            }
            if(value=='search-help'){
               this.view_tabs[1].active=true;
            }
            this.alertModal=data
            switch(value){
                case 'search-help':
                        this.search_type="Estas: en Gootwork favor con favor"
                        this.$nextTick(()=>{
                            this.$refs.myPosition.mapObject.openPopup()
                        });
                    break;
                case "help":
                    this.search_type="Estas: en Gootwork favor con favor"
                    this.getLocation();
                    break;
                case 'symptoms-help':
                        this.$nextTick(()=>{
                            this.$refs.myPosition.mapObject.openPopup()
                        });
                    break;
                case 'busines':
                    this.search_type="Estas: en Gootwork negocios"
                    this.getLocation();

                    break;
            }
            this.helpModalStorage.set(value);

        },
        isTabActive:function(index){
            var active=this.tabs[index].active;
            this.tabs.forEach(element=>{
                element.active=false;
            });
            this.tabs[index].active=!active;
        },
        getidentity(){
            this.identity = initVue.getIdentity().identity
            this.token = initVue.getIdentity().token
            this.session = initVue.isLogged(this.identity, this.token)
            //console.log(this.identity)
    
        },

        
        getdefaultcoordinates(){
            var data={
                city:'Huancayo'
            }
            this.searchOfficeId()
            /*
            CountriesService.list(data).then(res=>{
                let {countries} = res.data
                //console.log(countries)
                this.latitude = countries.coordenates.latitude
                this.longitude = countries.coordenates.longitude
            })
            */
        },
        sendMyUbication(){
            try{
                var symptoms=this.symptomsStorage.get()
                var user={
                    type:symptoms.type,
                    user:symptoms.user,
                    location:{
                        coordinates:[this.longitude,this.latitude],
                    }
                };  
                if(this.time_get==0){
                    this.$socket.emit('location:user-symptoms',user)
                    var mtime=setInterval(()=>{
                        if(this.time_get>=60){
                            this.time_get=0; 
                            clearInterval(mtime)                         
                        }
                        else{
                            this.time_get++;
                        }
                    },1000)
                }
                else{
                    return;
                }
            }
            catch($e){
                console.log($e)
            }

        },
        sendLocation:function(){
                if(this.user_location_cache!=null){
                    if(this.user_location_cache[0]!=this.longitude){
                        if(this.shared_location_all==true){
                            this.sendMyUbication();
                        }
                        else{
                            this.getLocation();
                        }
                    }
                }
                else{
                    if(this.shared_location_all==true){
                        this.sendMyUbication();                            
                    }
                    else{
                        this.getLocation();
                    }                 
                }
                this.user_location_cache=[this.longitude,this.latitude]
                //this.$socket.emit('location:user',user);
        },
        
        addMakerMaps:function(data){
            var newMarker=[];
            
            if(this.name_company==''){
                if(this.id_company!=0){
                    var index=data.findIndex((el)=>{
                        return el.company._id_company==this.id_company
                    })
                    if(index!=-1){
                        this.name_company=data[index].company_data?data[index].company_data.name:'';
                    }
                }
            }
            if(data !=null){
                this.newMaker=[];
                this.datacovid19=[];
                data.forEach(element=>{
                    if(element.location.coordinates){
                        if(element.type){
                            if(element.type=='user-covid19'){
                                this.datacovid19.push(
                                    {
                                        type:element.type,
                                        latitude:element.location.coordinates[1],
                                        longitude:element.location.coordinates[0],
                                    }
                                )
                                newMarker.push(
                                    {
                                        type:element.type,
                                        latitude:element.location.coordinates[1],
                                        longitude:element.location.coordinates[0],
                                    }
                                )
                            }
                            else{
                                newMarker.push(
                                    {
                                        type:element.type,
                                        latitude:element.location.coordinates[1],
                                        longitude:element.location.coordinates[0],
                                        channel:element.user._id_user,
                                        created_at:element.created_at,
                                        color:element.user.priority=='alta'?'fa5252':"ffc107",
                                        user:{
                                            ...element.user,
                                        }
                                    }
                                )
                            }
                        }
                    }
                    
                })
                this.newMaker=newMarker;
                this.checkedAlertCovid()

            }
        },
        clearLocation(){
            navigator.geolocation.clearWatch(this.watchID)
        },
        meLocation:function(){
            axios.get(`user/location/${this.latitude}/${this.longitude}`)
            .then(res=>{
                //console.log(res.data)
            })
        },
        menushow(){
                document.getElementById("sidebar").style = `
                    transform: translateX(0);
                `
        },
        menuhide(){
            document.getElementById("sidebar").style = `
                translateX(-100%);
            `
        },
        selectUserHelp:function(data){
            this.$router.push(`/conversation-user?type=user&datauser=${data.user._id}&color=${data.color}`)
        },
        selectUser:function(data){
            //console.log(this.latitude,this.longitude)
            this.session = JSON.parse(localStorage.getItem('user'))
            if(!this.session){
                EventBus.$emit('goLogin')
                return;
            }
            var user=this.usersStorage.get()||null;
            var user_send={
                id_conversation:data.user._id_user,
                location:[this.longitude,this.latitude],
                user:{
                    _id:this.identity?this.identity._id:null,
                    name:user.fullname,
                    avatar:user.photo,
                    phone:user.phone
                }
            }
            this.$socket.emit('helping:user',user_send)
            
            this.$router.push(`/conversation-user?type=user-help&datauser=${data.user._id_user}&color=${data.color}`)            
        },
        selectLocal:function(data){
            
            this.companyStorage.remove();
            this.orderStorage.remove();
            this.cartStorage.remove();
            this.orderDetailStorage.remove();
            var storage={
                id_company:data.company._id_company,
                id_office:data.company._id_office,
                name_sede:data.company.sede,
                category:data.company.category,
                name_company:data.company.name,
                latitude:data.latitude,
                longitude:data.longitude,
            }
            this.companyStorage.set(storage);
            this.$router.push(`services/${data.company._id_company}`)
        },
        sendRoom:function(data){
            this.$.emit.dataemit('room',data.channel);
        },
        checkedLocation:function(){
            //console.log('log');
            this.locationFirst=true;
            var i=1;
            var me =this;
            var interval= setInterval(function(){
                var position=me.recuvaLocation;
                
                //console.log(position);
                if(position.latitude!=me.latitude&&position.longitude!=me.longitude){
                    me.longitude=position.longitude;
                    me.latitude=position.latitude;
                    me.sendLocation();
                    
                }
            },60000)
        },
        getCheckedCurrentLocation: async  function(){
            this.successpositioncondition=await this.activeLocationStorage.get()==true?true:false;
            if(this.successpositioncondition==true){
               if(navigator.geolocation){     
                    navigator.geolocation.getCurrentPosition(this.successPosition,this.failurePosition);
                }
                else{
                    alert('not supported')
                }
                return;
            }
        },
        getCurrentLocation:function(){
            if(this.successpositioncondition){
                this.successpositioncondition=false;
                this.activeLocationStorage.set(false);
                return;
            }

            if(navigator.geolocation){     
                navigator.geolocation.getCurrentPosition(this.successPosition,this.failurePosition);
            }
            else{
                alert('not supported')
            }
        },
        recuvaLocation:function(){
            if(navigator.geolocation){
                this.watchID=navigator.geolocation.watchPosition(this.successPosition,this.failurePosition,{
                    timeout:60000,
                })
                //navigator.geolocation.clearWatch(this.watchID)
            }
            else{
                alert('not supported')
            }
        },
        successPosition(position){
            this.activeLocationStorage.set(true);
            this.latitude=position.coords.latitude;
            this.longitude=position.coords.longitude;
            this.locationStorage.set([this.longitude,this.latitude]);
            //var direction= await this.ubigeoDirection({lat:position.coords.latitude, lng:position.coords.longitude})
            //console.log(direction)
            this.successpositioncondition = true
            this.sendLocation();
            //this.meLocation();
        },
        failurePosition:function(err){
            switch(error.code) {
                case error.PERMISSION_DENIED:
                    successpositioncondition=false;
                    break;
                case error.POSITION_UNAVAILABLE:
                    break;
                case error.TIMEOUT:
                    break;
                case error.UNKNOWN_ERROR:
                    break;
            }
            this.getdefaultcoordinates()
            //this.checked()
        },
        checked:function(){
            //this.sendLocation();
            this.recuvaLocation();
            this.marker.forEach(element => {
                var g=this.getKilometros(this.latitude,this.longitude,element.latitude,element.longitude);
                if(parseFloat(g)<=5){
                    //console.log(this.getKilometros(this.latitude,this.longitude,element.latitude,element.longitude));
                    this.newMaker.push(element);
                }
            });
        },
        getKilometros:function(lat1,lon1,lat2,lon2){
            
            var rad =function(x){return x*Math.PI/180;}
            var radio=6378.137;
            var dLat=rad(lat2-lat1);
            var dLon=rad(lon2-lon1);

            var a =Math.sin(dLat/2)*Math.sin(dLat/2)*Math.cos(rad(lat1))+Math.cos(rad(lat2))*Math.sin(dLon/2)*Math.sin(dLon/2);
            var c=2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));
            var d=radio*c;
            
            return d.toFixed(3);
        }
    }
}
</script>
